const NESTED_LAYER_SELECTOR = [
  '[data-radix-popper-content-wrapper]',
  '[data-radix-popover-content]',
  '[data-radix-select-content]',
  '[data-radix-dropdown-menu-content]',
  '[data-radix-menu-content]',
  '[data-radix-dialog-content]',
].join(',')

export function isNestedLayerEvent(event: {
  target: EventTarget | null
  detail?: { originalEvent?: Event }
}) {
  const original = event.detail?.originalEvent?.target
  const target = original instanceof Element ? original : event.target
  return target instanceof Element && target.closest(NESTED_LAYER_SELECTOR) !== null
}
